import React from 'react'
import { Box } from '@node-space/ui-components'
import { ContactsSearch } from 'components/Contacts/ContactsSearch'

export const ContactAssignSearch = () => {
  return (
    <Box width="full">
      <ContactsSearch />
    </Box>
  )
}
